import { RemoteUser } from '../../../data/usecases/users/remote-user'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const apiToForm = (response: any) => (
  {
    fullname: response.fullname,
    phoneNumber: response?.phoneNumber,
    email: response.email,
    username: response.username,
    documentType: response.documentType,
    document: response.document,
    profiles: response.profiles.map((v: any) => JSON.stringify(v)),
    stablishmentTables: response.stablishmentTables.map((table: any) => String(table.id)),
    hasAllTables: response.hasAllTables ? 'true' : 'false',
  }
)

export const makeUsers = (stablismentId: number) => (
  new RemoteUser(
    `/stablishments/${stablismentId}/users`,
    makeAxiosHttpClient(),
  )
)
